// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CocosKeelingIslands from '../_raw/flag/icon_flag_cocos_keeling_islands.png';

export default () => <img src={CocosKeelingIslands} alt="CocosKeelingIslands" />;
